import { type RadarOrderPlacedParams } from './radar-conversion-tracking.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Tracks conversion events for Radar.
 * @see {@link https://docs.radar.com/api#log-a-conversion}
 * @see {@link https://docs.radar.com/sdk/react-native#conversions}
 */

export function trackRadarMenuViewed(_restaurantSlug: string) {
  // Native only.
}

export function trackRadarOrderPlaced(_params: RadarOrderPlacedParams) {
  // Native only.
}
